import { IconMoneybag, IconBookFilled, IconUsersGroup, IconClock } from "@tabler/icons-react"
import { icon } from "../functions/icons"
import { Badge } from "../atoms/badges"
import { GridLayout, VerticalLayout } from "./layout"
import { Spinner } from "../atoms/spinner"
import { color } from "chart.js/helpers"
import { EditCourseModal } from "./customModals"
import { useState } from "react"
import I from "@editorjs/link"

export function CourseComp({onClick, title, lessons, duration, image, status, className, AI, error, onRetry, pageType, removeCourseId, onRemoveCourse, stepId, costumColumnsTemplate, style}) {
    if (image == "" || !image) {
        image = image || `https://ui-avatars.com/api/?name=${title}`
    }
    const [isEditing, setIsEditing] = useState(false);
    const statusMap = {
        published: {
            name: "gepubliceerd",
            background: "var(--published-background)",
            color: "var(--published)",
        },
        notPublished: {
            name: "bijwerken",
            background: "var(--not-published-background)",
            color: "var(--not-published)",
        },
        finished: {
            name: "afgerond",
            background: "var(--finished-background)",
            color: "var(--finished)",
        },
        inProgress: {
            name: "bezig",
            background: "var(--in-progress-background)",
            color: "var(--in-progress)",
        },
        inactive: {
            name: "inactief",
            background: "#F0F0F0",
            color: "#6B6B6B",
        },
        delete: {
            name: "verwijderen",
            background: "var(--error-100)",
            color: "var(--error-600)",
        }
    };
    const handleStatusClick = (statusName) => {
        if (statusName === "bijwerken") {
            setIsEditing(true);
        }        
    };

    const handleDelete = () => {
        onRemoveCourse?.(removeCourseId, stepId);
    };

    const { name: statusName, background: statusBackground, color: statusColor } = statusMap[status] || statusMap.notPublished;
    return (
        
        <>
        <div onClick={!error ? onClick : null} className={`${className} vertical relative course-comp standard-rounded standard-border ${statusMap}`}>
             <img className="course-img" src={image} />
             <div className="courses-container">
                <div className="small-standard-padding"><p className="standard-text course-title">{title}</p></div>
                <GridLayout className="small-standard-padding no-padding-top" gap="0.75rem" columnsTemplate={ costumColumnsTemplate || "0.2fr auto auto"} style={style}>
                    <IconText
                        icon2={'clock'}
                        backgroundColor="var(--primary-100)"
                        iconColor="var(--primary-600)"
                        label={duration}
                        tooltip={"Lengte"}
                        tooltipBackground={"var(--primary-800)"}
                        tooltipLocation={"center"}

                    />
                    <IconText
                        icon2={'book'}
                        backgroundColor="var(--error-100)"
                        iconColor="var(--error-600)"
                        label={String(lessons)}
                        tooltip={"Aantal lessen"}
                        tooltipBackground={"var(--error-600)"}
                        tooltipLocation={"center"}
                    />
                    <IconText
                        onClick={() => handleStatusClick(statusName)}
                        icon2={statusName}
                        backgroundColor={statusBackground}
                        iconColor={statusColor}
                        tooltip={statusName} 
                        tooltipBackground={statusColor}
                        tooltipLocation={"left"}
                    />
                    {pageType === "Workflow" && (
                    <IconText
                        onClick={(e) => { e.stopPropagation(); handleDelete();}}
                        icon2={'trash'}
                        backgroundColor="var(--error-100)"
                        iconColor={"var(--error-600)"}
                        tooltip={"Verwijderen"}
                        tooltipBackground={"var(--error-600)"}
                        tooltipLocation={"left"}
                    />
                    )}
                </GridLayout>
             </div>
              {error && (<div className="error-indicator-wrapper"> <p className="small-text error-text">Genereren mislukt!</p><div className="error-indicator" onClick={onRetry}>{icon('refresh', 24, "var(--error-600)")} </div></div>)}
            {AI && (<VerticalLayout className="absolute center" style={{ top: "50%", left: "50%", transform: "translate(-50%, -50%)",}}>
            <Spinner size="5rem" thickness="2px" color="primary-600"/>
            <p className="small-text-dark">Even geduld...</p>
            </VerticalLayout>)}
        </div>
          {/* <EditCourseModal visible={isEditing} /> */}
        </>
        
    )
}

// export function CourseComp({ reviews, duration, lessons,title,price,onClick}) {
//     return (
//         <div onClick={onClick} className='vertical course-comp standard-rounded standard-border'>
//             <img className="course-img primary-background-300"/>
//             <div className="horizontal small-standard-padding"><p className="standard-text semi-bold">{title}</p><p className="standard-text grey-600">{price}</p></div>
//             <div className="horizontal small-standard-padding" style={{paddingTop:0}}>
//                 <IconText
//                     icon2={'clock'}
//                     label={duration}
//                 />
//                 <IconText
//                     icon2={'book'}
//                     label={lessons}
//                 />
//                 <IconText
//                     icon2={'clock'}
//                     label={duration}
//                 />
//             </div>
//        </div>
//     )
// }

export function IconText({ icon2, label, backgroundColor, marginBottom, iconColor, tooltip, tooltipBackground, size=17, tooltipLocation, className, onClick }) {
    return (
        <div data-testid={"icon-text-1"} className={`horizontal icon-container ${className}`} onClick={onClick ? onClick : null}>
            <div
                className="icon-wrapper"
                style={{
                    background: backgroundColor,
                    padding: label ? "0px 0.5rem" : "0px",
                    width: label ? "auto" : "28px",
                    gap: label ? "0.25rem" : "0px",
                    color: iconColor,
                    marginBottom: marginBottom
                }}
            >
                {icon(icon2, size)}
                <div className="tooltip-container">{tooltip && <span className={`tooltip ${tooltipLocation}`} style={{ backgroundColor: tooltipBackground }}>{tooltip}</span>}</div>
                { label && <p className="small-text">{label}</p> }
            </div>
        </div>
    );
}


